import {
  ATTENDANCE_STATUS,
  IAttendanceByUser,
  IAttendanceByUserExtended,
  TAttendanceByUserRecord,
  IAttendanceSummaryMetrics,
  IAttendanceByCourse,
} from 'src/apis/__shared/attendance.interfaces';
import { mockUserDetails } from '../users/userDetailsMock';
import { mockUserAction } from '../users/userAction';

// Helper function to create attendance record
const createUserAttendanceRecord = (
  attendanceId: string,
  date: string,
  status: ATTENDANCE_STATUS,
  comment?: string
): TAttendanceByUserRecord => ({
  attendanceId,
  date,
  attendanceStatus: status,
  comment,
  actions: {
    created: mockUserAction,
    updated: mockUserAction,
  },
});

// Helper function to calculate summary metrics
const calculateSummaryMetrics = (
  records: TAttendanceByUserRecord[]
): IAttendanceSummaryMetrics => {
  const totalPresent = records.filter(
    (r) => r.attendanceStatus === ATTENDANCE_STATUS.PRESENT
  ).length;
  const totalLate = records.filter(
    (r) => r.attendanceStatus === ATTENDANCE_STATUS.LATE
  ).length;
  const totalAbsent = records.filter(
    (r) => r.attendanceStatus === ATTENDANCE_STATUS.ABSENT
  ).length;
  const totalHalfDay = records.filter(
    (r) => r.attendanceStatus === ATTENDANCE_STATUS.HALF_DAY
  ).length;
  const totalHoliday = records.filter(
    (r) => r.attendanceStatus === ATTENDANCE_STATUS.HOLIDAY
  ).length;
  const totalLateWithExcuse = records.filter(
    (r) => r.attendanceStatus === ATTENDANCE_STATUS.LATE_WITH_EXCUSE
  ).length;
  const totalDays = records.length;
  const attendanceRate =
    totalDays > 0 ? parseFloat(((totalPresent / totalDays) * 100).toFixed(1)) : 0;
  const tardinessRate =
    totalDays > 0 ? parseFloat(((totalLate / totalDays) * 100).toFixed(1)) : 0;
  const excusedAbsentRate =
    totalDays > 0
      ? parseFloat(((totalLateWithExcuse / totalDays) * 100).toFixed(1))
      : 0;
  const unexcusedAbsentRate =
    totalDays > 0
      ? parseFloat(((totalAbsent / totalDays) * 100).toFixed(1))
      : 0;

  return {
    totalPresent,
    totalLate,
    totalAbsent,
    totalHalfDay,
    totalHoliday,
    totalLateWithExcuse,
    attendanceRate,
    tardinessRate,
    excusedAbsentRate,
    unexcusedAbsentRate,
  };
};

const attendanceRecords: TAttendanceByUserRecord[] = [
  createUserAttendanceRecord('1', '2024-01-01', ATTENDANCE_STATUS.PRESENT, 'Present'),
  createUserAttendanceRecord('2', '2024-01-02', ATTENDANCE_STATUS.ABSENT, 'Absent'),
  createUserAttendanceRecord('3', '2024-01-03', ATTENDANCE_STATUS.LATE, 'Late'),
  createUserAttendanceRecord('4', '2024-01-04', ATTENDANCE_STATUS.PRESENT, 'Present'),
  createUserAttendanceRecord('5', '2024-01-05', ATTENDANCE_STATUS.HALF_DAY, 'Half Day'),
  createUserAttendanceRecord('6', '2024-01-06', ATTENDANCE_STATUS.HOLIDAY, 'Holiday'),
  createUserAttendanceRecord('7', '2024-01-07', ATTENDANCE_STATUS.PRESENT, 'Present'),
  createUserAttendanceRecord('8', '2024-01-08', ATTENDANCE_STATUS.LATE_WITH_EXCUSE, 'Late with excuse'),
  createUserAttendanceRecord('9', '2024-01-09', ATTENDANCE_STATUS.ABSENT, 'Absent'),
  createUserAttendanceRecord('10', '2024-01-10', ATTENDANCE_STATUS.PRESENT, 'Present'),
  createUserAttendanceRecord('11', '2024-01-11', ATTENDANCE_STATUS.PRESENT, 'Present'),
  createUserAttendanceRecord('12', '2024-01-12', ATTENDANCE_STATUS.LATE, 'Late'),
];

export const mockAttendanceByUser: IAttendanceByUser = {
  userDetails: mockUserDetails.basicDetails,
  attendanceRecords,
  summary: calculateSummaryMetrics(attendanceRecords),
};

// Mock attendance by course
const mockCourseAttendance: IAttendanceByCourse[] = [
  {
    courseId: 'course-1',
    courseName: 'Woodworking - 1 (1st Semester)',
    attendanceRate: 90.0,
    present: 27,
    late: 0,
    excusedAbsent: 3,
    unexcusedAbsent: 0,
    records: attendanceRecords.slice(0, 6),
  },
  {
    courseId: 'course-2',
    courseName: 'AP Psychology - 3 (1st Semester)',
    attendanceRate: 96.6,
    present: 28,
    late: 0,
    excusedAbsent: 1,
    unexcusedAbsent: 0,
    records: attendanceRecords.slice(6, 12),
  },
];

export const mockAttendanceByUserExtended: IAttendanceByUserExtended = {
  ...mockAttendanceByUser,
  courses: mockCourseAttendance,
};
